export const HeaderTestID = 'ReminderSuccess.HeaderTestID';
